export default __webpack_public_path__ + "static/media/ic_marker.36c9a3e7.svg";